import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { postInformationEntityList } from 'src/api/information-entity/list';
import { LanguageEnum } from 'src/components/pages/components/LanguageSelect/const';
import { InformationEntity } from 'src/api/types';
import isNil from 'lodash/isNil';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends Omit<SelectProps<number>, 'value' | 'onChange'> {
    value?: InformationEntity;
    onChange?: (v: TemplateProps['value']) => void;
    lang?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, lang, ...restProps } = props;

    const [originData, setOriginData] = useState<InformationEntity[]>();

    const [options, setOptions] = useState<
        {
            value: number;
            label: string;
        }[]
    >();

    const { run } = useRequest(
        (keyword?: string) =>
            postInformationEntityList({
                activeFlag: 1,
                langList: !isNil(lang)
                    ? lang === LanguageEnum.All
                        ? [lang]
                        : [LanguageEnum.All, lang!]
                    : undefined,
                keyword,
            }),
        {
            refreshDeps: [lang],
            debounceWait: 300,
            debounceLeading: false,
            debounceTrailing: true,
            onSuccess: (res) => {
                setOriginData(res.data);
                setOptions(
                    res.data?.map((d) => {
                        return {
                            value: d.id!,
                            label: d.name!,
                        };
                    })
                );
            },
        }
    );

    const onSearch = (v: string) => {
        run(v);
    };

    const onValueChange = (v: number) => {
        const t = originData?.find((d) => d.id === v);
        onChange?.(t);
    };

    return (
        <Select
            value={value?.id}
            onChange={(v) => onValueChange(v)}
            options={options}
            showSearch
            filterOption={false}
            onSearch={onSearch}
            placeholder={/* 请选择信息实体 */UdeskLocales['current'].components.infoEntitySelect.index.pleaseSelectAnInformationEntity}
            {...restProps}
        />
    );
});

export default Template;
